export const CLEAN_ERROR = 'CLEAN_ERROR';
export const cleanError = ()=>({type: CLEAN_ERROR});



// WEBPACK FOOTER //
// ./src/actions/error.js